import { Divider } from "primereact/divider";
import { AddPageHeader } from "../Common/Utils";

const PrivacyAndTerms = () => {
  return (
    <div>
      {AddPageHeader("Privacy and terms")}
      <div className="reduce-width">
        <Divider align="center">
          <h1>Privacy and terms</h1>
        </Divider>
        <div className="privacy-terms-reduced-width">
          <p>
            Access{" "}
            <a
              href="/pdf/privacy-and-terms.pdf"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "black",
                textDecoration: "underline",
              }}
            >
              Privacy and terms
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyAndTerms;
